var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.globalModule[_vm.globalGetters.GET_LOADING])?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"rgb(122, 225, 89)"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }